module.exports = __webpack_public_path__ + "img/h.87a58b57.jpg";